import React, { useEffect, useRef, useState } from "react";
import style from "../woundAssessment.module.scss";
import PDFIcon from "../../../../static/images/pdfIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { setAssessmentHistory, setDetailAssessment, setTransferFrom, setWoundAssessment } from "../../../../app/patientSlice";
import { useNavigate, useParams } from "react-router-dom";
import { isAdministrator } from "../../../../utils/rbac";
import { useAdminView } from "../../../../hooks/useAdminView";

const AssessmentThreeDotMenu = ({
  assessment,
  patientData,
  modalOpen,
  handleLockUnlock,
  openDeleteConfirmation,
  setReEvalMergeConfirm,
  setAssessmentId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientId } = useParams();
  const isAdminView = useAdminView();
  const userRole = useSelector((state) => state.user);
  const adminAccess = isAdministrator(userRole?.role);

  const [clickThreeDots, setClickThreeDots] = useState("");
  const [openTooltip, setOpenTooltip] = useState(false);
  const [hoverUnlockIcon, setHoverUnlockIcon] = useState(false);
  const [hoverMergeIcon, setHoverMergeIcon] = useState(false);
  const [hoverTransferIcon, setHoverTransferIcon] = useState(false);
  const [hoverDeleteIcon, setHoverDeleteIcon] = useState(false);

  const wrapperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (!wrapperRef?.current?.contains(event.target)) {
      setOpenTooltip(false);
      setClickThreeDots("");
    } else {
      setOpenTooltip(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const threeDotPanelClick = (assessmentID) => {
    dispatch(setDetailAssessment({}));
    setClickThreeDots(assessmentID);
    setOpenTooltip(true);
  };

  const onTransferChange = (valueId) => {
    dispatch(setTransferFrom("wound_level"));
    navigate(`/patients/${patientId}/assessment/${valueId}/transferwoundassessment`, {
      state: isAdminView,
    });
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset"));
  };

  const onMergeChange = (assessmentId, reEvalCount) => {
    if (reEvalCount > 0) {
      setReEvalMergeConfirm(true);
      setAssessmentId(assessmentId);
    } else {
      navigate(`/patients/${patientId}/assessment/${assessmentId}/mergewoundassessment`, {
        state: isAdminView,
      });
      dispatch(setDetailAssessment({}));
      dispatch(setAssessmentHistory({}));
      dispatch(setWoundAssessment("reset"));
    }
  };

  return (
    <div className={`col-lg-2 col-md-12 pr-0 ${isAdminView && style.full_height}`}>
      {(isAdminView || (patientData?.isConsolidatedPdfEnable === 1 && assessment?.reEvalSequence > 0) || adminAccess) && (
        <div className={`${style.Three_Dots_Panel}`} onClick={() => threeDotPanelClick(assessment.id)}>
          <i
            className="fa fa-ellipsis-v"
            style={assessment.id !== clickThreeDots ? { color: "#464646" } : { color: "#919191" }}
            aria-hidden="true"
          ></i>
        </div>
      )}
      {openTooltip && assessment.id === clickThreeDots && (
        <div className={`${style.threeDotsTooltip}`} ref={wrapperRef}>
          {adminAccess && assessment.reEvalSequence < 1 && (
            <div
              className={`${style.lockSection} ${assessment?.isSigned === 0 && style.toggle_shells_disabled}`}
              onMouseOver={() => setHoverUnlockIcon(true)}
              onMouseLeave={() => setHoverUnlockIcon(false)}
            >
              <i
                className={assessment?.isLocked === 1 ? "fa fa-lock" : "fa fa-unlock-alt"}
                aria-hidden="true"
                style={{ fontSize: "19px", color: hoverUnlockIcon ? "#ffffff" : "#505f79", padding: "0 6px" }}
              ></i>
              <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>{assessment?.isLocked === 1 ? "Locked" : "Unlocked"} </p>

              <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}>
                <input
                  type="checkbox"
                  name={assessment?.id}
                  className="custom-control-input"
                  id={assessment?.id}
                  data-testid={"toggleSwitch"}
                  defaultChecked={assessment?.isLocked === 1}
                  onChange={() => handleLockUnlock(assessment?.id, assessment?.isLocked, assessment?.isSigned)}
                  disabled={assessment?.isSigned === 0}
                />
                <label className={`custom-control-label ${style.toggle_switch}`} htmlFor={assessment?.id}></label>
              </div>
            </div>
          )}
          {patientData?.isConsolidatedPdfEnable === 1 && assessment?.reEvalSequence > 0 && (
            <div className={style.downloadPdfSection} onClick={() => modalOpen(assessment.id, assessment.title)}>
              <span className={`${style.pdf_link} pl-1`}>
                <img src={PDFIcon} alt="" style={{ width: "15px", height: "15px" }} />
              </span>
              <p>Download PDF</p>
              <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
            </div>
          )}
          {adminAccess && (
            <>
              <div
                className={style.mergeSection}
                onMouseOver={() => {
                  setHoverMergeIcon(true);
                }}
                onMouseLeave={() => {
                  setHoverMergeIcon(false);
                }}
                onClick={() => onMergeChange(assessment.id, assessment.reEvalSequence)}
              >
                <svg
                  data-name="Component 124 – 3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="25"
                  viewBox="0 0 32 32"
                  style={{ paddingLeft: "3px" }}
                >
                  <path data-name="Rectangle 194" style={{ fill: "none" }} d="M0 0h32v32H0z" />
                  <path
                    d="M22.221 3a1.131 1.131 0 0 1 1.131 1.131v18.09a1.131 1.131 0 0 1-1.131 1.131H4.131A1.131 1.131 0 0 1 3 22.221V4.131A1.131 1.131 0 0 1 4.131 3zM12.045 5.261H5.261v6.783h2.262v-2.26l3.392 3.392-3.392 3.392v-2.261H5.261v6.783h6.784v-2.261h2.261v2.261h6.784v-6.783h-2.261v2.261l-3.392-3.392 3.392-3.392v2.26h2.261V5.261h-6.783v2.262h-2.262zm2.261 9.045v2.261h-2.261v-2.26zm0-4.523v2.261h-2.261v-2.26z"
                    transform="translate(2 3)"
                    style={{ fill: !hoverMergeIcon ? "#505f79" : "#ffffff" }}
                  />
                </svg>
                <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>Merge </p>
                <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
              </div>
              <div
                className={`${style.transferSection}`}
                onMouseOver={() => {
                  setHoverTransferIcon(true);
                }}
                onMouseLeave={() => {
                  setHoverTransferIcon(false);
                }}
                onClick={() => onTransferChange(assessment.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  shapeRendering="geometricPrecision"
                  textRendering="geometricPrecision"
                  imageRendering="optimizeQuality"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  viewBox="0 0 441 512.399"
                  width="25"
                  height="21"
                  style={{ paddingLeft: "3px" }}
                >
                  <path
                    fill="#000"
                    fillRule="nonzero"
                    d="M102.778 354.886c-5.727 0-10.372-4.645-10.372-10.372s4.645-10.372 10.372-10.372h85.568a148.22 148.22 0 00-7.597 20.744h-77.971zm0-145.37c-5.727 0-10.372-4.645-10.372-10.372s4.645-10.372 10.372-10.372h151.288c5.727 0 10.373 4.645 10.373 10.372s-4.646 10.372-10.373 10.372H102.778zm0 72.682c-5.727 0-10.372-4.646-10.372-10.372 0-5.728 4.645-10.373 10.372-10.373h143.273c2.829 0 5.394 1.134 7.264 2.971a149.511 149.511 0 00-25.876 17.774H102.778z"
                    style={{ fill: !hoverTransferIcon ? "#505f79" : "#ffffff" }}
                  />
                  <path
                    fill="#000"
                    d="M324.263 278.925c32.231 0 61.419 13.067 82.545 34.192C427.933 334.241 441 363.43 441 395.66c0 32.236-13.067 61.419-34.192 82.544-21.126 21.126-50.311 34.195-82.545 34.195-32.232 0-61.418-13.069-82.542-34.195-21.126-21.125-34.195-50.312-34.195-82.544s13.069-61.417 34.195-82.543c21.125-21.125 50.308-34.192 82.542-34.192zM60.863 0h174.81c3.382 0 6.384 1.619 8.278 4.123l110.107 119.12a10.288 10.288 0 012.746 7.011h.052v119.819a149.42 149.42 0 00-20.752-3.112v-92.212h-43.666v-.042h-.161c-22.046-.349-39.33-6.222-51.694-16.784-12.849-10.979-20.063-26.615-21.503-46.039a10.16 10.16 0 01-.096-1.405V20.752H60.863c-11.02 0-21.049 4.518-28.321 11.79-7.272 7.272-11.79 17.301-11.79 28.321v338.276c0 11.015 4.521 21.038 11.796 28.312 7.278 7.28 17.31 11.801 28.315 11.801h120.749a148.33 148.33 0 008.116 20.752H60.863c-16.73 0-31.958-6.849-42.987-17.881C6.852 431.099 0 415.882 0 399.139V60.863C0 44.114 6.846 28.894 17.87 17.87 28.894 6.846 44.114 0 60.863 0zm178.873 29.983v60.432c1.021 13.738 5.819 24.536 14.302 31.784 8.668 7.404 21.488 11.544 38.4 11.835v-.038h43.443L239.736 29.983zm24.119 381.587v-31.799c0-6.683 5.451-12.132 12.12-12.132h34.763v-22.387c.166-4.041 1.51-6.904 4.028-8.557 6.739-4.495 13.386 1.643 18.071 5.895l46.127 45.371c4.818 4.896 4.884 10.557 0 15.45l-47.393 46.461c-4.484 3.985-10.599 8.914-16.805 4.762-2.518-1.686-3.862-4.529-4.028-8.568V423.69h-34.763c-6.615 0-12.12-5.449-12.12-12.12z"
                    style={{ fill: !hoverTransferIcon ? "#505f79" : "#ffffff" }}
                  />
                </svg>
                <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>Transfer</p>
                <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
              </div>
              <div
                className={`${style.deleteSection}`}
                onClick={() => openDeleteConfirmation(assessment.id, assessment.reEvalSequence, assessment.title)}
                onMouseOver={() => {
                  setHoverDeleteIcon(true);
                }}
                onMouseLeave={() => {
                  setHoverDeleteIcon(false);
                }}
              >
                <svg
                  data-name="Component 124 – 3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 32 32"
                  style={{ paddingLeft: "3px" }}
                >
                  <path data-name="Rectangle 194" style={{ fill: "none" }} d="M0 0h32v32H0z" />
                  <path
                    data-name="Delete Dark"
                    d="M71.714 67.366v-2.573a.857.857 0 0 1 .857-.857h6.857a.857.857 0 0 1 .857.857v2.573h6.857a.857.857 0 1 1 0 1.714H64.857a.857.857 0 0 1 0-1.714zm1.714 0h5.143v-1.714h-5.142zm-6 20.571a.857.857 0 0 1-.857-.857v-18h18.858v18a.857.857 0 0 1-.857.857zm6-5.143a.857.857 0 0 0 .857-.857v-8.571a.857.857 0 1 0-1.714 0v8.571a.857.857 0 0 0 .858.858zm5.143 0a.857.857 0 0 0 .857-.857v-8.571a.857.857 0 0 0-1.714 0v8.571a.857.857 0 0 0 .857.858z"
                    transform="translate(-60 -59.936)"
                    style={{ fill: !hoverDeleteIcon ? "#505f79" : "#ffffff" }}
                  />
                </svg>
                <p
                  style={{ alignItems: "baseline", paddingTop: "2px", paddingLeft: "5px" }}
                  // onClick={() => openDeleteConfirmation(assessment.id, assessment.reEvalSequence, assessment.title)}
                >
                  Delete{" "}
                </p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AssessmentThreeDotMenu;
